<template>
  <div class="change--wrapper" v-loading="loading">
    <el-row :gutter="16">
      <el-col :lg="10" :md="24" :xl="10">
        <el-card :style="`height: ${isAdd ? '320px' : '390px'}`" class="card--box content-card-box">
          <div class="header--title" slot="header">{{ $t('stores::products-info::base_attr') }}</div>
          <el-form :model="detailForm" :rules="basicRules" label-position="left" label-width="80px" ref="basicForm">
            <el-form-item label="SPU" v-if="!isAdd">{{ detailForm.id }}</el-form-item>
            <el-form-item :label="$t('stores::products-info::name')" prop="title">
              <el-input
                :placeholder="$t('stores::products-info::input_goods_name')"
                class="input-item"
                v-model="detailForm.title"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('system::responsible::供应商')" prop="supplierId">
              <div style="display: flex">
                <el-select
                  :popperAppendToBody="false"
                  @change="handleSelectSupplier"
                  class="input-item"
                  v-model="detailForm.supplierId"
                >
                  <el-option
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    v-for="item in supplierList"
                  ></el-option>
                </el-select>
                <!-- <i @click="showAddSupplier = true" class="iconfont iconadd icon-add-btn"></i> -->
                <i @click="showAddSupplier = true" class="el-icon-plus add-btn"></i>
              </div>
            </el-form-item>
            <el-form-item :label="$t('stores::products-info::category')" prop="categoryId">
              <div style="display: flex">
                <el-cascader
                  :appendToBody="false"
                  :options="categoryOpt"
                  :props="{ label: 'name', value: 'id', children: 'childrens', checkStrictly: true }"
                  class="input-item"
                  v-model="detailForm.categoryId"
                ></el-cascader>
                <!-- <i @click="handlerAddCateGory" class="iconfont iconadd icon-add-btn"></i> -->
                <i @click="handlerAddCateGory" class="el-icon-plus add-btn"></i>
              </div>
            </el-form-item>
            <el-form-item :label="$t('stores::products-info::currency')" prop="spuCurrency">
              <div>
                <el-select :popperAppendToBody="false" style="width: 100%" v-model="detailForm.spuCurrency">
                  <el-option label="USD" value="USD"></el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
      <el-col :lg="14" :md="24" :xl="14">
        <el-card :title="$t('stores::products-info::goods_detail')" class="card--box">
          <div class="header--title" slot="header">{{ $t('stores::products-info::goods_detail') }}</div>
          <div>
            <rich-editor
              :height="isAdd ? 232 : 302"
              :placeholder="$t('stores::products-info::input_goods_detail')"
              v-model="detailForm.spuLongDesc"
            ></rich-editor>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-card class="card--box img-content-wrapper content-card-box">
        <div class="header--title" slot="header">{{ $t('stores::products-info::goods_info') }}</div>
        <div style="margin-bottom: 10px">{{ $t('stores::products-info::商品图片') }}</div>
        <el-form :model="detailForm" :rules="basicRules" ref="imgForm">
          <el-form-item label label-width="0" prop="spuImages">
            <!-- <div style="display: flex;align-items: center">
                   <div
                    class="prodinfo--edit__imgBox"
                    v-for="(item, index) in detailForm.spuImages"
                    :key="index"
                    @mouseenter="hoverImgList.push(item)"
                    @mouseleave="leaveImg(item)"
                >-->
            <!-- <el-popover placement="top-start" trigger="hover"> -->
            <!-- <img :src="item" style="width: 250px;height: 250px" /> -->
            <!-- <el-image :src="item"></el-image> -->
            <!-- </el-popover> -->
            <!-- <div class="prodinfo--edit__wrapper" v-if="hoverImgList.includes(item)">
                      <i class="el-icon-circle-close" @click="closeImage(item)"></i>
                    </div>
                </div>-->
            <pictureCard
              folder="product"
              style="border-radius: 4px; border: 1px solid #dcdfe6; padding: 12px 12px 16px"
              v-model="detailForm.spuImages"
            ></pictureCard>
            <!-- <img-upload @uploadSuccess="uploadSpuImg">
                    <div class="prodinfo--edit__picAdd">
                      <div>+</div>
                      <div class="title">上传图片</div>
                    </div>
                  </img-upload>
                </div>-->
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="space-between">
          <el-col>
            <el-button
              type="primary"
              @click="() => addSku()"
              :disabled="selectedSkuOpt.length ? false : detailForm.skus.length >= 1"
            >
              {{ $t('stores::products-info::add_sku') }}
            </el-button>
            <el-button @click="multipleDialog = true" :disabled="!skuSelections.length">
              {{ $t('stores::products-info::batch_edit') }}
            </el-button>
            <!-- <el-button>批量删除</el-button> -->
          </el-col>
          <el-col style="text-align: end">
            <el-button @click="addAttr">{{ $t('stores::products-info::dialog_manager_attr') }}</el-button>
          </el-col>
        </el-row>
        <z-table
          :data="detailForm.skus"
          ref="skuTable"
          :max-height="300"
          :pagination="false"
          :columns="skuTableColumns"
          style="margin-top: 24px"
          @selection-change="onSkuSelections"
        >
          <template #imageUrl="{ row }">
            <ZImg :src="row.imageUrl" style="width: 60px; height: 60px" fit="contain"></ZImg>
          </template>
          <template #weight="{ row }">{{ $dataCheck(row.weight) }}{{ row.weightUnit }}</template>
          <template #purchasePrice="{ row }">{{ $dataCheck(row.purchasePrice) }}</template>
          <template #compareAtPrice="{ row }">{{ $dataCheck(row.compareAtPrice) }}</template>
          <template #salePrice="{ row }">{{ $dataCheck(row.salePrice) }}</template>
          <template #safeInventory="{ row }">{{ $dataCheck(row.safeInventory) }}</template>
          <template #skuInventory="{ row }">{{ $dataCheck(row.skuInventory) }}</template>
          <!-- <template #options="{row}">
            <div style="display:flex">
              <div class="option-list" v-for="(item, index) in row.options" :key="index">
                <div>{{ item.name }}</div>
                <div>{{ $dataCheck(item.value) }}</div>
              </div>
            </div>
          </template> -->
          <template v-for="(val, index) in selectedSkuOpt" #[val.label]="{ row }">
            <div :key="index">
              {{ row.options[index].value }}
            </div>
          </template>
          <template #opt="scope">
            <el-button type="text" @click="onEdit(scope.row, scope.$index)">
              {{ $t('system::function::edit') }}
            </el-button>
            <el-button type="text" @click="onCopy(scope.row, scope.$index)">
              {{ $t('stores::products-info::copy') }}
            </el-button>
            <el-button type="text" style="color: #ff0022" @click="deleteSkuData(scope.row)">
              {{ $t('system::function::delete') }}
            </el-button>
          </template>
        </z-table>
      </el-card>
    </el-row>
    <!-- 尺码表 -->
    <!-- <el-row :gutter="16">
      <el-col :lg="12" :md="24" :xl="12">
        <el-card :title="$t('stores::products-info::goods_chart')" class="card--box">
          <div class="header--title" slot="header">{{ $t('stores::products-info::goods_chart') }}</div>
          <div>
            <rich-editor
              :placeholder="$t('stores::products-info::input_goods_chart')"
              v-model="detailForm.spuSizeDesc"
            ></rich-editor>
          </div>
        </el-card>
      </el-col>
    </el-row> -->
    <!-- <el-row>
      <el-col :class="['fixed-sku-wrapper', isAdd ? '' : 'top-height']">
        <el-card class="card--box">
          <div class="mb-12 btn-wrapper">
            <el-button
              @click="() => addSku()"
              class="sku-btn"
              icon="el-icon-plus"
              size="mini"
              type="primary"
              v-show="selectedSkuOpt.length || (!selectedSkuOpt.length && !detailForm.skus.length)"
            >
              {{ $t('stores::products-info::add_sku') }}
            </el-button>
            <el-button
              @click="editSkuBtn"
              class="sku-btn"
              size="mini"
              type="default"
              v-show="!!skuSelections.length && !moreEdit"
            >
              {{ $t('stores::products-info::batch_edit') }}
            </el-button>
            <el-button @click="addAttr" class="setting-attr-btn" icon="el-icon-setting " type="primary"></el-button>
          </div>
          <skuTable
            :data.sync="detailForm.skus"
            :selectedSkuOpt="selectedSkuOpt"
            @onAddAttr="addAttr"
            @onMoreEdit="onMoreEdit"
            @remove="deleteSkuData"
            @save="onSaveSkuTable"
            @selections="onSkuSelections"
            ref="skuTable"
          ></skuTable>
        </el-card>
      </el-col>
    </el-row> -->

    <footer-fixed>
      <el-button @click="back" size="small">{{ $t('stores::products-info::return') }}</el-button>
      <el-button :loading="saveLoading" @click="handleSave" class="mlr16" size="small" type="primary">
        {{ $t('stores::products-info::save') }}
      </el-button>
    </footer-fixed>
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('stores::products-info::dialog_manager_attr')"
      :visible.sync="showSetAttributes"
      bodyHeight="350px"
      custom-class="manage-dialog-modal"
      width="500px"
    >
      <el-row>
        <el-col :span="13" class="col-manage-item" style="border-right: 1px solid rgba(0, 0, 0, 0.1)">
          <div class="input-search-box">
            <el-input
              :placeholder="$t('stores::products-info::input_attr')"
              style="width: 100%"
              v-model="attrSearchVal"
            >
              <i @click="getAttrList" class="el-input__icon el-icon-search" slot="prefix"></i>
            </el-input>
            <el-tooltip
              v-auth="'stores::product-manager::attr-add'"
              class="item"
              effect="dark"
              :content="$t('system::common::text::add')"
              placement="top"
            >
              <i @click="addProp" class="el-input__icon el-icon-plus add-btn"></i>
            </el-tooltip>
          </div>
          <!--        <div style='text-align: right;padding-right: 10px'>-->
          <!--          <el-checkbox @change=''></el-checkbox>  全选-->
          <!--        </div>-->
          <ul class="prodinfo--edit__attrList">
            <li :key="item.id" v-for="item in attrList">
              <span>{{ item.name }}</span>
              <el-checkbox
                :value="selectedAttrList.map(i => i.name).includes(item.name)"
                @change="selectAttr(item)"
              ></el-checkbox>
            </li>
          </ul>
        </el-col>
        <el-col :span="11">
          <ul class="col-manage-item prodinfo--edit__attrList">
            <li :key="item.id" v-for="item in selectedAttrList">
              <span>{{ item.name }}</span>
              <i @click="closeAttr(item)" class="el-icon-circle-close" style="cursor: pointer"></i>
            </li>
          </ul>
        </el-col>
      </el-row>

      <span class="dialog-footer" slot="footer">
        <el-button @click="showSetAttributes = false">{{ $t('system::common::btn::cancel') }}</el-button>
        <el-button @click="changeAttributes" type="primary">{{ $t('system::common::btn::confirm') }}</el-button>
      </span>
    </el-dialog>
    <!-- 添加商品 -->
    <skuModal
      :data="detailForm.skus"
      :drawRow="backRow"
      :selectedSkuOpt="selectedSkuOpt"
      :images="images"
      @save="onSave"
      ref="skuModal"
      @onAddAttr="addAttr"
      v-model="visable"
    ></skuModal>
    <skuMultiple v-model="multipleDialog" @edit="editSkuBtn"></skuMultiple>
    <!-- 供应商穿透模块 -->
    <cateModal :cateData="cateInfoData" :visible.sync="showAddCate" @save="handleCateSave"></cateModal>
    <edit-dialog :isNew="true" @getListData="initData" ref="edit" v-model="showAddSupplier"></edit-dialog>
    <EditAttrDialog :isEdit="isAttrEdit" @updateData="handleAddAttrProp" ref="editAttr"></EditAttrDialog>
  </div>
</template>

<script>
import EditDialog from '@/views/supplier/components/editDialog'
import EditAttrDialog from '@/views/commodity-center/prop/components/editDialog'
import cateModal from '@/views/commodity-center/category/category-modal'
import RichEditor from '@/components/rich-editor'
import * as Api from '@/server/product'
import skuTable from '../components/sku-table'
import skuModal from '../components/sku-modal'
import skuMultiple from '../components/sku-multiple'
import { createHash } from '@/utils'
import pictureCard from '@/components/common/picture-list'
import ImgUpload from '@/views/commodity-center/products/product-info/components/ImgUpload'
import { tableColumns } from './config'
let TABLE_ITEM = {
  fakeId: '',
  sku_code: '',
  salePrice: '', // 销售价格
  compareAtPrice: '', // 参考价
  purchasePrice: '', // 成本价格
  imageUrl: '', // 图片
  grams: '', // 重量
  weight: '', // 商品重量
  weightUnit: 'g', // 商品重量单位,
  options: [],
  color: '',
  size: '',
  skuInventory: '',
  safeInventory: '',
  length: '',
  wide: '',
  high: '',
  sizeUnit: 'cm',
}

export default {
  name: 'index',
  components: {
    EditAttrDialog,
    skuTable,
    cateModal,
    RichEditor,
    ImgUpload,
    pictureCard,
    EditDialog,
    skuModal,
    skuMultiple,
  },
  data() {
    return {
      isAttrEdit: false,
      loading: false,
      moreEdit: false,
      hoverImgList: [],
      skuSelections: [],
      cateInfoData: null,
      detailForm: {
        spu_code: '',
        title: '',
        supplier: '',
        supplierId: '',
        categoryId: [],
        spuSizeDesc: '',
        spuLongDesc: '',
        spuCurrency: 'USD',
        skus: [],
        spuImages: [],
        spuOptions: [],
      },
      basicRules: {
        title: [{ required: true, message: this.$t('stores::products-info::input_goods_name'), trigger: 'blur' }],
        supplierId: [
          { required: true, message: this.$t('stores::products-info::input_supplier_name'), trigger: 'blur' },
        ],
        spuCurrency: [{ required: true, message: this.$t('stores::products-info::input_currency'), trigger: 'blur' }],
        categoryId: [{ required: true, message: this.$t('stores::products-info::input_category'), trigger: 'blur' }],
        spuImages: [{ required: true, message: this.$t('stores::products-info::select_photos'), trigger: 'blur' }],
      },
      currentHover: '',
      showAddCate: false,
      showSetAttributes: false,
      isAdd: true,
      categoryOpt: [],
      supplierList: [],
      attrList: [],
      selectedAttrList: [],
      attrSearchVal: '',
      selectedSkuOpt: [],
      saveLoading: false,
      showAddSupplier: false,
      tableColumns: tableColumns,
      backRow: {
        type: 'edit',
        item: {},
        index: undefined,
      },
      visable: false,
      multipleDialog: false,
    }
  },
  async created() {
    this.initData()
  },
  activated() {
    this.getDetail()
  },
  computed: {
    skuTableColumns() {
      return [...this.tableColumns, ...this.selectedSkuOpt]
    },
    images() {
      return Array.from(
        new Set([...(this.detailForm.spuImages || []), ...(this.detailForm.skus || []).map(item => item.imageUrl)])
      )
    },
  },
  watch: {
    showSetAttributes(val) {
      if (val) this.selectedAttrList = [...this.selectedSkuOpt]
    },
    skuTableColumns: {
      handler() {
        this.$nextTick(() => {
          this.$refs.skuTable && this.$refs.skuTable.$refs.elTable && this.$refs.skuTable.$refs.elTable.doLayout()
        })
        // this.$forceUpdate()
      },
      deep: true,
      immediate: true,
    },
    // $route: {
    //   handler: function(to) {
    //     console.log(this.$route.name)
    //     if (to.params && to.params.id && to.params.id !== this.detailForm.id) {
    //       this.getDetail()
    //     }
    //   },
    //   immediate: true
    // }
  },
  methods: {
    async getDetail() {
      const urlParams = this.$route.params.id.split('+')
      if (urlParams[0] === 'add') {
        this.isAdd = true
      } else {
        this.isAdd = false
        this.loading = true
        await this.getAttrList()
        const res = await Api.getProduct(urlParams[0])
        this.loading = false
        if (res.data.code === this.$code) {
          this.detailForm = res.data.data
          if (res.data.data.skus[0].options) {
            this.selectedSkuOpt = res.data.data.skus[0].options.map(item => {
              const obj = this.attrList.find(attr => attr.name === item.name)
              return {
                label: item.name,
                list: item.list || (obj && obj.list) || [],
                prop: item.name,
                value: '',
                name: item.name,
                width: 100,
              }
            })
            this.detailForm.skus = JSON.parse(
              JSON.stringify(
                this.detailForm.skus.map(item => {
                  if (item.options && item.options.length) {
                    item.options = item.options.map(item => {
                      const obj = this.attrList.find(attr => attr.name === item.name)
                      item.list = (obj && obj.list) || []
                      return {
                        ...item,
                      }
                    })
                  }
                  return {
                    ...item,
                  }
                })
              )
            )
          } else {
            res.data.data.skus.forEach(item => {
              item.options = []
            })
          }

          this.selectedAttrList = this.detailForm.spuOptions.map(item => {
            const obj = this.attrList.find(attr => attr.name === item.name)
            return {
              id: item.id,
              list: (obj && obj.list) || [],
              name: item.name,
            }
          })
          // 是复制
          if (urlParams[1]) {
            delete this.detailForm.id
            this.detailForm.skus.forEach(item => {
              delete item.id
            })
            this.isAdd = true
            this.detailForm.title = this.detailForm.title + `(${this.$t('stores::products-info::copy')})`
          }
        }
      }
    },
    async handleAddAttrProp() {
      // 新增数据后 更新数据
      await this.getAttrList()
    },
    addProp() {
      this.$store.dispatch('buried', { event: 'StoreManagementClick', buttonName: '新增属性' })
      this.isAttrEdit = false
      this.$refs.editAttr.show()
    },
    handlerAddCateGory() {
      this.cateInfoData = {
        name: '',
        type: 'add',
        row: null,
        category: [],
        color: '',
      }
      this.showAddCate = true
    },
    reverseData(data, arr = []) {
      return data.childrens.map(item => {
        if (item.childrens && item.childrens.length) {
          arr.push(data.id)
          item.childrens = this.reverseData(item, JSON.parse(JSON.stringify(arr)))
          return {
            parentIds: arr,
            ...item,
          }
        } else {
          arr.push(data.id)
          if (item.childrens) delete item.childrens
          return {
            parentIds: arr,
            ...item,
          }
        }
      })
    },
    queryCategory() {
      Api.getProdCategories({
        page_num: 1,
        page_size: 100,
      }).then(res => {
        if (res.data.success) {
          this.categoryOpt = res.data.data.items.map((item, i) => {
            if (item.childrens.length) {
              item.childrens = this.reverseData(item, [])
            } else {
              if (item.childrens) delete item.childrens
            }

            return {
              ...item,
            }
          })
        }
      })
    },
    handleCateSave() {
      this.queryCategory()
    },
    initData() {
      this.queryCategory()
      Api.getSupplierList({
        page_num: 1,
        status: 1,
        page_size: 100,
      }).then(res => {
        if (res.data.success) {
          this.supplierList = res.data.data.items
        }
      })
    },
    checkDetailData() {
      let valList = []
      console.log(this.detailForm.skus)
      if (this.detailForm.skus.length !== 0) {
        this.detailForm.skus.forEach(item => {
          valList.push(item.salePrice)
          valList.push(item.compareAtPrice)
          valList.push(item.purchasePrice)
          valList.push(item.weight)
          valList.push(item.skuInventory)
          valList.push(item.safeInventory)
          if (item.options) {
            item.options.forEach(i => {
              valList.push(i.value)
            })
          }
        })
      } else {
        valList.push('')
      }
      return !(valList.includes('') || valList.includes(undefined))
    },

    handleSave() {
      this.$refs.basicForm.validate(valid1 => {
        this.$refs.imgForm.validate(valid2 => {
          console.log(valid1, valid2, this.basicForm, '错误')
          if (valid2 && valid1) {
            if (!this.checkDetailData()) {
              return this.$message.warning(this.$t('stores::products-info::message_input_sku'))
            }
            // 构造数据
            const SpuOptList = []
            const skuOptList = []
            if (this.detailForm.skus[0].options[0]) {
              // 先构造数组
              this.detailForm.skus[0].options.forEach(item => {
                SpuOptList.push({ name: item.name, spuOptionValues: [] })
              })
              this.detailForm.skus.forEach(item => {
                skuOptList.push(item.options.map(sku => sku.value))
                item.options.forEach(i => {
                  SpuOptList.forEach(opt => {
                    if (opt.name === i.name && !opt.spuOptionValues.some(v => v.value === i.value)) {
                      opt.spuOptionValues.push({ value: i.value })
                    }
                  })
                })
              })
            }
            let flag = 0
            this.detailForm.spuOptions = SpuOptList
            this.detailForm.spuOptions.forEach(item => {
              if (
                new Set(Object.values(item.spuOptionValues.map(item => item.value))).size !==
                Object.values(item.spuOptionValues.map(item => item.value)).length
              ) {
                flag++
              }
            })
            skuOptList.reduce((prev, next, index, list) => {
              if (list.slice(index).some(item => prev === JSON.stringify(item))) {
                flag++
              }
              return JSON.stringify(next)
            }, '')
            if (flag !== 0) {
              return this.$message.warning(this.$t('stores::products-info::message_not_same'))
            }
            this.detailForm.categoryId = this.detailForm.categoryId[this.detailForm.categoryId.length - 1]
            this.saveLoading = true
            Api.productSave(this.detailForm)
              .then(res => {
                if (res.data.success) {
                  this.$message.success(this.$t('system::tip::control_success'))
                  this.keepUpdate('/products-info')
                  this.closeCurTab()
                  this.$router.push({
                    name: 'products-info',
                    params: {
                      activeTab: 'UN_PUBLISHED',
                    },
                  })
                }
                this.saveLoading = false
              })
              .catch(() => {
                this.saveLoading = false
              })
          }
        })
      })
    },
    back() {
      this.$router.back()
    },
    addSku(add, isVisable) {
      const _param = JSON.parse(JSON.stringify(TABLE_ITEM))
      _param.fakeId = createHash(4)
      _param.options = JSON.parse(JSON.stringify(this.selectedSkuOpt))
      if (add) {
        this.detailForm.skus.push(_param)
      } else {
        this.onAdd(_param, isVisable)
      }
    },
    onSkuSelections(data) {
      // if (!data.length) {
      //   this.$refs.skuTable.onMore(false)
      // }
      this.skuSelections = data
    },
    editSkuBtn(data) {
      console.log(this.skuSelections)
      console.log(this.detailForm)
      // this.$refs.skuTable.onMore(true)
      this.detailForm.skus = this.detailForm.skus.map(el => {
        if (this.skuSelections.some(i => i.id === el.id)) {
          el = { ...el, ...data }
          console.log(el)
        }
        return el
      })
      this.skuSelections = []
    },
    onMoreEdit(bool) {
      this.moreEdit = bool
    },
    onSaveSkuTable(row) {
      this.detailForm.skus.push(row)
      console.log(this.detailForm.skus, '变化')
    },
    onSave(row, type) {
      if (type === 'add' || type === 'copy') {
        this.detailForm.skus.push(row)
        this.$emit('save', row)
      } else {
        const index = this.backRow.index
        this.detailForm.skus.splice(index, 1, row)
        console.log(index, this.data, row)
        // this.$emit('update:data', this.data.splice(index, 1, row))
      }
    },
    async addAttr() {
      await this.getAttrList()
      this.showSetAttributes = true
    },
    getAttrList() {
      Api.getAttrList({
        page_num: 1,
        page_size: 100,
        option_name: this.attrSearchVal,
      }).then(res => {
        this.attrList = res.data.data
      })
    },
    onCopy(row, index) {
      this.visable = true
      this.backRow.type = 'copy'
      const data = this.$deepClone(row)
      if (data.hasOwnProperty('id')) {
        delete data.id
      } else if (data.hasOwnProperty('fakeId')) {
        delete data.fakeId
      }
      data.fakeId = createHash(4)
      this.backRow.item = data
      this.backRow.index = index
    },
    onEdit(row, index) {
      this.visable = true
      this.backRow.type = 'edit'
      this.backRow.item = row
      this.backRow.index = index
      console.log('edit', row)
    },
    onAdd(row, isVisable) {
      this.backRow.type = 'add'
      this.backRow.item = row
      if (!isVisable) {
        this.visable = true
      } else {
        this.$refs.skuModal.updateAttr()
      }
    },
    changeAttributes() {
      if (this.selectedAttrList && this.selectedAttrList.length > 3) {
        this.$message.warning(this.$t('stores::products-info::message_three_attr'))
        return false
      }
      this.selectedSkuOpt = this.selectedAttrList.map(item => {
        return {
          label: item.name,
          list: item.list || [],
          prop: item.name,
          width: 100,
          value: '',
          name: item.name,
        }
      })
      // 无属性，清空添加的sku
      if (this.selectedSkuOpt.length === 0) this.detailForm.skus = this.detailForm.skus.splice(0, 1)
      this.detailForm.skus.forEach((item, index) => {
        item.options = this.selectedSkuOpt.map(option => ({
          ...option,
          value:
            (item.options.find(i => i.name === option.name) && item.options.find(i => i.name === option.name).value) ||
            '',
        }))
      })
      this.showSetAttributes = false
      this.addSku(undefined, true)
    },
    selectAttr(row) {
      if (!this.selectedAttrList.find(item => item.name === row.name)) {
        this.selectedAttrList.push(row)
      } else {
        this.selectedAttrList = this.selectedAttrList.filter(item => item.name !== row.name)
      }
    },
    closeAttr(row) {
      this.selectedAttrList = this.selectedAttrList.filter(item => item.name !== row.name)
    },
    deleteSkuData(row) {
      this.$confirm(
        this.$t('product-manager::products-info::delete_goods_tip'),
        this.$t('product-manager::products-info::delete_goods_title'),
        {
          confirmButtonText: this.$t('system::common::btn::confirm'),
          cancelButtonText: this.$t('system::common::btn::cancel'),
        }
      ).then(() => {
        console.log(row)
        if (row.fakeId) {
          // 新增的数据
          this.detailForm.skus = this.detailForm.skus.filter(item => !(item.fakeId === row.fakeId))
        } else {
          this.detailForm.skus = this.detailForm.skus.filter(item => !(item.id === row.id))
        }
      })
    },
    uploadSpuImg(url) {
      this.detailForm.spuImages.push(url)
    },
    uploadSkuImg(url, row) {
      console.log(url, row)
      row.imageUrl = url
    },
    leaveImg(row) {
      this.hoverImgList = this.hoverImgList.filter(item => row !== item)
    },
    closeImage(row) {
      this.detailForm.spuImages = this.detailForm.spuImages.filter(item => item !== row)
    },
    changeNames(v, row, index) {
      row.options[index].value = v
      console.log(this.detailForm)
    },
    blurInputNumber(e) {
      const reg = new RegExp(/^(\.*)(\d+)(\.?)(\d{0,2}).*$/g)
      if (!reg.test(e.target.value)) {
        this.$message.warning(this.$t('stores::products-info::message_input_number'))
        e.target.value = ''
      } else {
        e.target.value = Number(e.target.value).toFixed(2)
      }
    },
    handleSelectSupplier(val) {
      this.supplierList.forEach(item => {
        if (item.id === val) {
          this.detailForm.supplier = item.name
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.btn-wrapper {
  height: 28px;
}
.input-search-box {
  position: relative;
  display: flex;
  padding-right: 12px;
  .add-btn {
    font-size: 14px;
    cursor: pointer;
    flex: 0 0 auto;
    margin-left: 8px;
    color: #010517;
    background: #f0f0f0;
    line-height: 40px;
    display: inline-block;
    text-align: center;
    height: 40px;
    width: 40px;
    border-radius: 5px;
    top: 0;
  }
}
/deep/ .el-card .el-card__header {
  border-bottom: 1px solid #dcdfe6;
}
.setting-attr-btn {
  float: right;
  width: 28px;
  height: 28px;
  padding: 0;
  font-size: 16px;
}
.change--wrapper {
  padding-bottom: 45px;
}
::v-deep {
  .manage-dialog-modal {
    .col-manage-item {
      min-height: 300px;
      box-sizing: border-box;
    }
  }
}
.info-content-wrapper {
  height: 706px;
  display: flex;
  flex-direction: column;
  ::v-deep {
    .content-card-box {
      .el-card__body {
        padding: 0 16px;
      }
    }
  }

  .img-content-wrapper {
    height: 336px;
  }
}
.fixed-sku-wrapper {
  margin-bottom: 16px;
  height: 686px;

  .card--box {
    height: 100%;
  }
}
.input-item {
  // width: 200px;
  flex: 1;
}
.card--box {
  margin: 10px 0;
}

.iconadd {
  margin-left: 5px;
}
.header--title {
  font-size: 16px;
  font-weight: 500;
  color: #010517;
  line-height: 40px;
}

.prodinfo--edit__picAdd {
  .title {
    font-size: 14px !important;
  }
}
.prodinfo--edit {
  &__table {
    ::v-deep {
      .el-input {
        width: 80px;
      }
    }
    ///deep/ .el-input-number {
    //  width: 60px;
    //  display: inline-block;
    //}
  }
  &__tableImgAdd {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  &__tablePicAdd {
    cursor: pointer;
    box-sizing: border-box;
    width: 40px;
    height: 40px;
    display: inline-block;
    line-height: 36px;
    text-align: center;
    font-size: 24px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }
  &__picAdd {
    width: 80px;
    height: 80px;
    margin-right: 8px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    cursor: pointer;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    color: #3a416f;
    font-size: 40px;
    .title {
      font-size: 20px;
    }
  }
  &__attrList {
    display: inline-block;
    padding: 10px;
    width: 186px;
    max-height: 350px;
    overflow: auto;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 5px 0;
    }
  }
  &__imgBox {
    display: inline-block;
    width: 80px;
    height: 80px;
    overflow: hidden;
    margin-right: 6px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &__wrapper {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(255, 255, 255, 0.6);
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
  }
}
.add-btn {
  font-size: 14px;
  cursor: pointer;
  flex: 0 0 auto;
  margin-left: 8px;
  color: #0560fd;
  background: #f0f0f0;
  line-height: 40px;
  display: inline-block;
  text-align: center;
  height: 40px;
  width: 40px;
  border-radius: 5px;
  top: 0;
}
.option-list {
  border: 1px solid #dddddd;
  border-radius: 4px;
  display: flex;
  height: 38px;
  div {
    padding: 13px;
  }
  div + div {
    border-left: 1px solid #dddddd;
  }
}
.option-list + .option-list {
  margin-left: 17px;
}
</style>
